type Environment = "local" | "production";

const environments: Record<Environment, string> = {
  local: "http://localhost:3000/api/",
  production: "https://testing-qudra.kayan-healthcare.com/api/", 
};

export const getCurrentEnvironment = (): Environment => {
  const hostname = window.location.hostname;
  
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "local";
  }

  return "production";
};

export const API_BASE_URL: string = environments[getCurrentEnvironment()];
